// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"161d9769","140":"db8dd20a","227":"361d0933","326":"f38799ad","378":"627bc4ba","387":"5c12ec52","667":"aa8e506a","738":"806677fb","768":"2abc964e","842":"9123e83c"}[chunkId] + ".chunk.js";
};